import { applyPageMetadata } from "@/lib/page-metadata";
import { createFileRoute } from "@tanstack/react-router";
import { PracticeAreasIndex } from "./practice-areas";
import { breadcrumbSchema, jsonLdScript, organizationSchema } from "@/lib/seo";

export const Route = createFileRoute("/practice-areas/")({
  head: () => applyPageMetadata("/practice-areas", {
    meta: [
      { title: "SEO by Practice Area, Personal Injury, DUI, Family & More" },
      { name: "description", content: "Specialist SEO programs for every legal practice area. Personal injury, DUI, family, criminal defense, estate planning, immigration, bankruptcy & more." },
      { property: "og:title", content: "SEO by Practice Area | PageOne Lawyers" },
      { property: "og:description", content: "Specialist SEO for every legal practice area." },
      { property: "og:url", content: "https://pageonelawyers.com/practice-areas" },
    ],
    links: [{ rel: "canonical", href: "https://pageonelawyers.com/practice-areas" }],
    scripts: [
      jsonLdScript(organizationSchema()),
      jsonLdScript(breadcrumbSchema([
        { label: "Home", path: "/" },
        { label: "Practice Areas", path: "/practice-areas" },
      ])),
    ],
  }),
  component: PracticeAreasIndex,
});